import CalendarAssetsModal from '../../calendar/calendar-assets-modal';
import CreateNewCalendarItem from './partials/CreateNewCalendarItem';
import TeamCalendar from './calendar/TeamCalendar';
import ScheduleDateSetup from './partials/ScheduleDateSetup';

Vue.component('team-calendar-page', {
    components: {
        TeamCalendar,
        CreateNewCalendarItem,
        CalendarAssetsModal,
        ScheduleDateSetup,
    },
    props: ['schedule', 'categories'],
    data() {
        return {
            attributes: null,
            currentSchedule: this.schedule,
        };
    },
});
